import APIClient from './index';
import _ from 'lodash';

// Threads (ConciergeThread with isPlayground=true)
export const getThreads = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('/Playground/threads')
      .then(response => resolve({ threads: response.data.threads }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createThread = body => {
  return new Promise((resolve, reject) => {
    APIClient.post('/Playground/threads', body)
      .then(response => resolve({ thread: response.data }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateThread = (id, body) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/Playground/threads/${id}`, body)
      .then(response => resolve({ thread: response.data }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const deleteThread = id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`/Playground/threads/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Messages
export const getMessages = threadId => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/Playground/threads/${threadId}/messages`)
      .then(response => resolve({ messages: response.data.messages }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const clearMessages = threadId => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`/Playground/threads/${threadId}/messages`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Prompt Configs
export const getPromptConfigs = (type = null) => {
  return new Promise((resolve, reject) => {
    const params = type ? `?type=${type}` : '';
    APIClient.get(`/Playground/prompt-configs${params}`)
      .then(response => resolve({ configs: response.data.configs }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createPromptConfig = body => {
  return new Promise((resolve, reject) => {
    APIClient.post('/Playground/prompt-configs', body)
      .then(response => resolve({ config: response.data }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Chat
export const sendChatMessage = body => {
  return new Promise((resolve, reject) => {
    APIClient.post('/Playground/chat/send', body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Product Search
export const searchProducts = body => {
  return new Promise((resolve, reject) => {
    APIClient.post('/Playground/product-search', body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Datakeeper
export const runDatakeeper = body => {
  return new Promise((resolve, reject) => {
    APIClient.post('/Playground/datakeeper/run', body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const applyBioUpdate = body => {
  return new Promise((resolve, reject) => {
    APIClient.post('/Playground/datakeeper/apply', body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Sessions (grading/golden dataset)
export const saveSession = body => {
  return new Promise((resolve, reject) => {
    APIClient.post('/Playground/sessions/save', body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getAllSessions = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('/Playground/sessions')
      .then(response => resolve({ sessions: response.data.sessions }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getGoldenSessions = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('/Playground/sessions/golden')
      .then(response => resolve({ sessions: response.data.sessions }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Utility
export const getDefaultPrompts = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('/Playground/default-prompts')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getAvailableModels = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('/Playground/models')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
